import { useState } from "react";
import { Link } from "react-router-dom";
import { categories, news } from "@/mocks/content";
import { ListRow } from "@/components/feature/Cards";

export default function TabFeed() {
  const [active, setActive] = useState(categories[0].slug);
  const activeCat = categories.find((c) => c.slug === active)!;
  const list = news.filter((n) => n.category === active);
  return (
    <section className="mx-auto max-w-7xl px-4 pb-10 md:px-6">
      <div className="mb-5 flex items-end justify-between">
        <div>
          <p className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
            <span className="inline-block h-3 w-1 rounded-full bg-primary-500" />
            Live Columns
          </p>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-900 md:text-3xl">
            点栏目，看最新一手瓜讯
          </h2>
        </div>
      </div>

      {/* 分类切换 */}
      <div className="mb-5 flex flex-wrap gap-2">
        {categories.map((c) => (
          <button
            key={c.slug}
            onClick={() => setActive(c.slug)}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-1 py-1 text-sm font-medium transition-colors ${
              active === c.slug
                ? "bg-background-100"
                : "hover:bg-background-100"
            }`}
          >
            <span
              className={`inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 ${
                active === c.slug
                  ? "bg-primary-600 text-background-50"
                  : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              <i className={c.icon} />
              {c.name}
            </span>
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
        {list.map((item) => (
          <ListRow key={item.id} item={item} />
        ))}
      </div>

      <div className="mt-5 flex items-center justify-between rounded-xl border border-background-200 bg-background-100/60 px-4 py-3">
        <p className="text-sm text-foreground-600">
          当前栏目「{activeCat.name}」：{activeCat.tagline}
        </p>
        <Link
          to={`/category/${active}`}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
        >
          进入栏目
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}